/* eslint-disable prefer-template */
/* eslint-disable no-restricted-syntax */

import React, { useState, useEffect } from 'react';
import { BaseComponent } from 'components/BaseComponent';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import env from '../../../../../env';
import { Button } from '../../../../../components/Buttons';
import { HBox, VBox } from '../../../../../components/Box';
import { Check, Times } from '../../../../../components/Icon';
import { updateDocumentLayers, updateImageLayers } from '../../../../Documents/actions';
import { selectWork, selectWorks } from '../../../../Api/selectors';
import { REQUEST_UPDATE_DOCUMENT_LAYERS, REQUEST_UPDATE_IMAGE_LAYERS } from '../../../../Users/constants';
import { Loader } from '../../../../../components/Loader';
import cn from 'classnames';
import styles from './PhotoLayers.module.css';

const STATE = {
  top: null,
  bottom: null,
};

const Container = styled.div``;

class PhotoLayersComp extends BaseComponent {
  constructor(props) {
    super(props, { ...STATE });
    this.state = {
      ...STATE,
      countdown: null,
    };
  }

  componentDidMount() {
    this.props.fetch();
    this.setState({ step: +this.props.match.params.step });
  }

  save() {
    let layers = [];

    let currentLayers = this.getLayers();
    let currentToplayer = currentLayers.find(name => name.indexOf(':top') > -1)?.split?.(':')[0];
    let currentBottomlayer = currentLayers.find(name => name.indexOf(':bottom') > -1)?.split?.(':')[0];

    let top = this.state.top || currentToplayer;
    let bottom = this.state.bottom || currentBottomlayer;

    if (top === 'clear') top = null;
    if (bottom === 'clear') bottom = null;

    layers = [
      [top, 'top'],
      [bottom, 'bottom'],
    ]
      .filter(a => a[0])
      .map(b => b.join(':'));

    let string = layers.join(',');

    console.log(string);

    if (this.props.document?.id) {
      this.props.saveDocLayers(string, result => {
        debugger;
      });
    } else {
      this.props.saveImageLayers(string, result => {
        debugger;
      });
    }
  }

  getLayers() {
    let layers = this.props.document?.layers?.split?.(',') || [];
    return layers;
  }

  isActive(file, position) {
    if (this.state[position]) {
      return this.state[position] === file || (file == null && this.state[position] === 'clear');
    }

    if (this.getLayers().indexOf(`${file}:${position}`) > -1) return true;

    if (!file) return true;
    return false;
  }

  handleSave = () => {
    const isConfirmed = window.confirm('Er zitten kosten aan verbonden, weet je zeker dat je doorgaat?');
    if (isConfirmed) {
      this.save();
      this.setState({ countdown: 15 });
    }
  };

  componentDidUpdate(prevProps, prevState) {
    if (this.state.countdown !== null && this.state.countdown !== prevState.countdown) {
      if (this.state.countdown === 0) {
        window.location.reload();
      } else {
        setTimeout(() => {
          this.setState(prevState => ({ countdown: prevState.countdown - 1 }));
        }, 1000);
      }
    }
  }

  render() {
    if (!env.photo_layers) {
      return null;
    }

    return (
      <Container>
        {this.props.position === 'top' && (
          <div>
            <div className={styles.containerThumbnails}>
              <div className={styles.imageThumbnails} style={{ width: `${env.photo_layers.top.length * (100 + 10)}px` }}>
                {env.photo_layers.top.map(file => this.renderFile(file, 'top'))}
              </div>
            </div>
            <div className="d-flex gap-2">
              {this.props.loading ? (
                <Loader small />
              ) : (
                <Button primary={!this.isActive(null, 'top')} onClick={this.handleSave}>
                  {this.lbl('save')}
                </Button>
              )}
              <Button warning={!this.isActive(null, 'top')} onClick={this.setStateFn({ top: 'clear' })}>
                {this.lbl('cancel')}
              </Button>
            </div>
          </div>
        )}
        {this.props.position === 'bottom' && (
          <div>
            <div className={styles.containerThumbnails}>
              <div className={styles.imageThumbnails} style={{ width: `${env.photo_layers.top.length * (100 + 10)}px` }}>
                {env.photo_layers.bottom.map(file => this.renderFile(file, 'bottom'))}
              </div>
            </div>
            <div className="d-flex gap-2">
              {this.props.loading ? (
                <Loader small />
              ) : (
                <Button primary={!this.isActive(null, 'bottom')} onClick={this.handleSave}>
                  {this.lbl('Achtergrond verwijderen')}
                </Button>
              )}
              <Button warning={!this.isActive(null, 'bottom')} onClick={this.setStateFn({ bottom: 'clear' })}>
                {this.lbl('cancel')}
              </Button>
            </div>
          </div>
        )}
        {this.state.countdown !== null && <div>Page will reload in {this.state.countdown} seconds...</div>}
      </Container>
    );
  }

  renderFile(file, position) {
    console.log('file', file);
    console.log('position', position);
    return (
      <>
        <img
          src={`/storage/layers/${file}`}
          alt={`/storage/layers/${file}`}
          className={cn(styles.thumbnail, { [styles.active]: this.isActive(file, position) })}
          onClick={this.setStateFn({ [position]: file })}
        />
      </>
    );
  }
}

PhotoLayersComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    loading: selectWorks([REQUEST_UPDATE_DOCUMENT_LAYERS, REQUEST_UPDATE_IMAGE_LAYERS]),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    fetch() {
      //
    },
    saveDocLayers(layers, callback) {
      dispatch(updateDocumentLayers(ownProps.document.id, layers, callback));
    },
    saveImageLayers(layers, callback) {
      dispatch(updateImageLayers(ownProps.document, layers, callback));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const PhotoLayers = compose(withConnect, withRouter)(PhotoLayersComp);
